import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { PAGE_DISPUTE_PAYMENT } from '../../../constants/FraudAndDisputeConstants';
import { ContentContainer } from 'web-ui-components/lib/layout/containers';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export const ContactSeller = (props) => {
  const { content, setPage } = props;

  return (
    <ApplicationFormShell>
      <div className="col-xs-8 text-center">
        <img
          alt="reading a phone"
          src="../../../../images/bow/reading-phone.svg"
        ></img>
        <PageHeading>{content.contactSellerTitle}</PageHeading>
      </div>
      <ContentContainer>
        <p className="text-center">
          <strong>{content.contactSellerText1}</strong>
        </p>
      </ContentContainer>
      <ContentContainer>
        <p className="text-center">
          <strong>{content.contactSellerText2}</strong>
        </p>
      </ContentContainer>
      <div className="col-xs-8 text-center">
        <NavigationButton.Primary
          data-test-id="contacted-seller"
          labelText={content.yesIhaveContacted}
          onClick={() => {
            setPage(PAGE_DISPUTE_PAYMENT);
            AnalyticsUtil.analyticAction(
              config.analytics.analytics_experience_activity,
              config.analytics.analytics_event_method_interacted,
              config.analytics.analytics_action_dispute_contacted_the_seller,
              config.analytics.analytics_action_button_click
            );
          }}
        />
      </div>
    </ApplicationFormShell>
  );
};

ContactSeller.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
};
